// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__3FyJh"};